import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes=[
  {path:'/',component:()=>import('../views/Home.vue')},
  {path:'/p',component:()=>import('../views/Products.vue')},
  {path:'/p/detail/:skuKey',component:()=>import('../views/ProductDetail.vue')},
  {path:'/c',component:()=>import('../views/Cart.vue')},
  {path:'/login',component:()=>import('../views/Login.vue')},
  {path:'/help/:topic',component:()=>import('../views/Help.vue')}
]
export default new VueRouter({mode:'history',base:process.env.BASE_URL,routes,scrollBehavior(){return{x:0,y:0}}})

